import api from "../services/api";
import {
  PaymentAccountDTO,
  PaymentAccountSummaryDTO,
  TournamentPaymentAccountDTO,
  CreatePaymentAccountDTO,
  UpdatePaymentAccountDTO,
  LinkPaymentAccountDTO,
} from "../models/IPaymentAccount";
import { IServiceResponse } from "../types/api";

export const getAllPaymentAccounts = (): Promise<IServiceResponse<PaymentAccountDTO[]>> => api.get("paymentaccount");

export const getPaymentAccountById = (id: string): Promise<IServiceResponse<PaymentAccountDTO>> =>
  api.get(`paymentaccount/${id}`);

export const getPaymentAccountsByTournament = (
  tournamentId: string
): Promise<IServiceResponse<TournamentPaymentAccountDTO[]>> =>
  api.get(`paymentaccount/tournament/${tournamentId}`);

export const getActivePaymentAccountsByTournament = (
  tournamentId: string
): Promise<IServiceResponse<TournamentPaymentAccountDTO[]>> =>
  api.get(`paymentaccount/tournament/${tournamentId}/active`);

export const createPaymentAccount = (data: CreatePaymentAccountDTO): Promise<IServiceResponse<PaymentAccountDTO>> =>
  api.post("paymentaccount", data);

export const updatePaymentAccount = (
  id: string,
  data: UpdatePaymentAccountDTO
): Promise<IServiceResponse<PaymentAccountDTO>> => api.put(`paymentaccount/${id}`, data);

export const deletePaymentAccount = (id: string): Promise<IServiceResponse<boolean>> =>
  api.delete(`paymentaccount/${id}`);

export const linkPaymentAccountToTournament = (
  tournamentId: string,
  data: LinkPaymentAccountDTO
): Promise<IServiceResponse<boolean>> => api.post(`paymentaccount/tournament/${tournamentId}/link`, data);

export const unlinkPaymentAccountFromTournament = (
  tournamentId: string,
  paymentAccountId: string
): Promise<IServiceResponse<boolean>> =>
  api.delete(`paymentaccount/tournament/${tournamentId}/unlink/${paymentAccountId}`);

export const filterPaymentAccounts = (
  tournamentId?: string,
  isActive?: boolean,
  searchTerm?: string
): Promise<IServiceResponse<PaymentAccountDTO[]>> => {
  const params = new URLSearchParams();
  if (tournamentId) params.append("tournamentId", tournamentId);
  if (isActive !== undefined) params.append("isActive", isActive.toString());
  if (searchTerm) params.append("searchTerm", searchTerm);

  return api.get(`paymentaccount/filter?${params.toString()}`);
};

export const filterPaymentAccountsSummary = (
  tournamentId?: string,
  isActive?: boolean
): Promise<IServiceResponse<PaymentAccountSummaryDTO[]>> => {
  const params = new URLSearchParams();
  if (tournamentId) params.append("tournamentId", tournamentId);
  if (isActive !== undefined) params.append("isActive", isActive.toString());

  return api.get(`paymentaccount/filter/summary?${params.toString()}`);
};
